import React from 'react';

function TipsHome({ workflow }) {
  return (
    <React.Fragment>
      <section className="section tips py-40" id="tips">
        <div className="container">
          <div className="row flex flex-col md:flex-row items-center">
            <div
              className="w-full md:w-1/2 aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <div className="media-wrapper px-4">
                <picture>
                  <source
                    media="(max-width:465px)"
                    type="image/webp"
                    srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/make-your-video-small.webp"
                  />
                  <source
                    type="image/webp"
                    srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/make-your-video-small.webp"
                  />
                  <img
                    className="z-depth-1"
                    loading="lazy"
                    src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/make-your-video.png"
                    alt="Invideo Tips"
                  />
                </picture>
              </div>
            </div>
            <div
              className="w-full md:w-1/2 offset-md-1 tip-content aos-init aos-animate"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <div className="content flex justify-center md:justify-start flex-col items-center md:items-start md:ml-40">
                <h2 className="content-title text-2xl md:text-4xl text-brandPrimary">
                  Get Started Today
                </h2>
                <div className="pointers">
                  <div className="tip my-4 text-lg">
                    <span className="index">1.</span>
                    <span className="value ml-4">Login to InVideo.</span>
                  </div>
                  <div className="tip my-4 text-lg">
                    <span className="index">2.</span>
                    <span className="value ml-4">
                      Choose from hundreds of dazzling designs.
                    </span>
                  </div>
                  <div className="tip my-4 text-lg">
                    <span className="index">3.</span>
                    <span className="value ml-4">
                      Add your own magic touch.
                    </span>
                  </div>
                  <div className="tip my-4 text-lg">
                    <span className="index">4.</span>
                    <span className="value ml-4">
                      Edit till you love it. Publish.
                    </span>
                  </div>
                </div>
                <div className="action">
                  <div
                    aria-hidden
                    className="signUp-btn p-4 px-6 bg-brandPrimary text-white rounded-lg cursor-pointer"
                    onClick={workflow}
                    data-toggle="modal"
                    data-target="#authModal"
                  >
                    <h3 className="btn btn-secondary-gradient">
                      Create Free Account
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="section create-videos tips pb-20" id="tips">
        <div className="container">
          <div className="flex flex-col md:flex-row-reverse justify-evenly items-center">
            <div
              className="w-full md:w-1/2 offset-md-1 aos-init aos-animate"
              data-aos="fade-left"
              data-aos-duration="1000"
            >
              <div className="media-wrapper">
                <picture>
                  <source
                    media="(max-width:465px)"
                    type="image/webp"
                    srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/video-change-world-small.webp"
                  />
                  <source
                    type="image/webp"
                    srcSet="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/video-change-world-small.webp"
                  />
                  <img
                    className="z-depth-1"
                    loading="lazy"
                    src="https://d360zdw5tkn3j9.cloudfront.net/Template_Block_Assets/landing-page/video-change-world-small.png"
                    alt="Invideo Tips"
                  />
                </picture>
              </div>
            </div>
            <div
              className="w-full md:w-5/12 tip-content aos-init aos-animate"
              data-aos="fade-right"
              data-aos-duration="1000"
            >
              <div className="content flex justify-center md:justify-start flex-col items-center md:items-start md:mr-0">
                <h2 className="content-title text-2xl md:text-4xl text-brandPrimary">
                  Video is Key to Engaging with Audiences
                </h2>
                <div className="pointers">
                  <div className="tip my-4 text-lg">
                    <span className="index inline">1.</span>
                    <div className="value inline ml-4">
                      <strong>81%</strong> of businesses prefer to use Facebook
                      for their video marketing.{' '}
                      <a href="https://buffer.com/">(Buffer) </a>
                    </div>
                  </div>
                  <div className="tip my-4 text-lg">
                    <span className="index inline">2.</span>
                    <div className="value inline ml-4">
                      <strong>2.6x</strong> more time on pages with video than
                      without. <a href="https://wistia.com/">(Wistia) </a>
                    </div>
                  </div>
                  <div className="tip my-4 text-lg">
                    <span className="index inline">3.</span>
                    <div className="value inline ml-4">
                      Including a video on your landing page can boost your
                      conversion rate by up to <strong>80%</strong>.
                      <a href="https://unbounce.com/"> (Unbounce)</a>
                    </div>
                  </div>
                </div>
                <div className="action">
                  <div
                    aria-hidden
                    className="signUp-btn my-4 p-4 px-6 bg-brandPrimary text-white rounded-lg cursor-pointer"
                    onClick={workflow}
                  >
                    <h3 className="btn btn-secondary-gradient">
                      Create Free Account
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default TipsHome;
